import styled from 'styled-components';

export const TablesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem 3.2rem 4rem 1.5rem;
`;

export const TopContainerStories = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;
